import { useEvents } from "api/events";
import { useAppDispatch } from "app/hooks";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import { useLocation, useNavigate } from "react-router-dom";
import { updateImportedCampaigns } from "reduxState/campaigns/campaigns";
import { updateImportedGlobalAutomations } from "reduxState/globalManagement/globalManagement";
import {
  CampaignFEValues,
  CampaignTriggers,
  ImportType,
  TimeBasedCampaign,
} from "types/campaigns";
import { backendErrors } from "utilities/backendErrors";
import { links } from "utilities/links";
import { prepareInitialValues } from "../../utils/utils";
import { AutomationForm } from "../AutomationForm/AutomationForm";

export const EditImportedAutomation = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { useCustomEventSchemaDetails } = useEvents();
  const { message } = useMessage();
  const { state } = useLocation();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "automationsImportReview" }),
      path: links.automationsImportList,
    },
  };

  const campaignDataToEdit: CampaignFEValues = state.campaignData;

  const { data: selectedSchemaDetails } = useCustomEventSchemaDetails(
    campaignDataToEdit.trigger !== CampaignTriggers.INTERNAL_EVENT &&
      "event" in campaignDataToEdit
      ? campaignDataToEdit.event
      : undefined,
  );

  const initialValues = campaignDataToEdit
    ? {
        ...prepareInitialValues({
          campaignData: campaignDataToEdit,
          selectedSchemaDetails,
        }),
        active: false,
        translations: campaignDataToEdit.translations,
      }
    : undefined;
  const clearLink =
    state?.importType === ImportType.SINGLE
      ? links.automationsImportList
      : links.configDuplicationImport;

  return (
    <>
      <TopHeader
        title={state?.campaignData?.name}
        clearLink={clearLink}
        breadcrumbs={breadcrumbs}
      />
      <AutomationForm
        initialValues={initialValues as TimeBasedCampaign}
        initialErrors={backendErrors(state.errors)}
        onSaveCallback={(campaign) => {
          // SINGLE IMPORT
          if (state?.importType === ImportType.SINGLE) {
            dispatch(
              updateImportedCampaigns({
                importedId: state.importedId,
                campaign: campaign,
              }),
            );

            return navigate(links.automationsList);
          }
          // GLOBAL IMPORT UPDATE
          dispatch(
            updateImportedGlobalAutomations({
              importedId: state.importedId,
              campaign: campaign,
            }),
          );
          return navigate(links.configDuplicationImport);
        }}
        onCancelCallback={() => {
          if (state?.importType === "single") {
            return navigate(links.automationsImportList);
          }
          return navigate(links.configDuplicationImport);
        }}
      />
    </>
  );
};
